import React from 'react';

export default (_props) => {
  const { className, size, large, small, ...props } = _props;

  // small icon
  if ((size && size.toLowerCase() === 'small') || small) {
    return (
      <svg width="24" height="24" viewBox="0 0 24 24" className={`audiicon audiicon-small ${className ? className : ''}`} {...props}>
        <path d="M21,17.5 L6.5,17.5 L0.5,23 L0.5,4.5 C0.5,2.8 1.8,1.5 3.5,1.5 L23.5,1.5 L23.5,15 C23.6,16.3 22.6,17.4 21.2,17.5 C21.2,17.5 21.1,17.5 21,17.5 Z" stroke="currentColor" strokeWidth="1" fill="none" fillRule="evenodd"/>
      </svg>
    );
  }

  // large icon
  return (
    <svg width="48" height="48" viewBox="0 0 48 48" className={`audiicon audiicon-large ${className ? className : ''}`} {...props}>
      <path d="M40.5,33.5 L13.5,33.5 L2.5,44.5 L2.5,9.5 C2.5,6.7 4.7,4.5 7.5,4.5 L45.5,4.5 L45.5,28.5 C45.5,31.3 43.3,33.5 40.5,33.5 C40.5,33.5 40.5,33.5 40.5,33.5 Z" stroke="currentColor" strokeWidth="1" fill="none" fillRule="evenodd"/>
    </svg>
  );
};
